import { useState } from "react";

import { useProductCombos } from "Hooks/useProductCombos";

import { CATEGORIES } from "Constants/Categories";
import { ProductsFilterState } from "../components/Filters/interface";

const combosParams = {
  includeCombo: ["categories", "subcategories"],
  searchBudget: true,
};

export const useFilters = () => {
  const [search, setSearch] = useState<ProductsFilterState>({
    search: "",
    subcategories: "",
    categories: "1,2,3",
    services: "1",
  });

  const { combos, loadingCombos } = useProductCombos(combosParams);

  const { subcategories, categories } = combos ?? {};

  const { exam, checkup, test } = CATEGORIES;

  const categoriesOpts = categories
    ?.map((category) => {
      if ([exam, checkup, test].includes(category.id)) {
        return {
          category: category.category,
          id: category.id,
        };
      }

      return null;
    })
    .filter(Boolean);

  const subcategoriesOpts = subcategories?.filter(
    (subcategory) => subcategory.category_id === Number(search.categories)
  );

  const handleTypeSearch = (typeSearch: string) => {
    setSearch((prevSearch) => ({
      ...prevSearch,
      search: typeSearch,
    }));
  };

  const handleChangeFilter = (key: string, value: string | Object) => {
    if (key === "categories" && value) {
      setSearch((prevSearch) => ({
        ...prevSearch,
        [key]: String(value),
        subcategories: "",
      }));
      return;
    }

    setSearch((prevSearch) => ({ ...prevSearch, [key]: value }));
  };

  const clearFilter = async () => {
    const filtersCleared = {
      categories: "",
      search: "",
      subcategories: "",
      services: "4",
    };

    setSearch(filtersCleared);
  };

  return {
    handleTypeSearch,
    search,
    handleChangeFilter,
    subcategoriesOpts,
    clearFilter,
    categoriesOpts,
    loadingCombos,
  };
};
